<template>
	<div class="flex flex-col">
		<div class="grow text-center">
			<h2>{{ t("auth.passwordReset") }}</h2>
		</div>
		<div class="mt-4">
			<UpdatePasswordForm
				inputClass="bg-current/20 text-primary-content w-full"
				:label="$t('users.resetPassword')"
				@update:password="resetPassword"
			/>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { useApi } from "@soft-db/monitoring-api-client";
import UpdatePasswordForm from "./UpdatePasswordForm.vue";

const { t } = useI18n();

const props = defineProps<{
	code: string;
}>();

const auth = useApi().auth();

const router = useRouter();

async function resetPassword(password: string) {
	const success = await auth.resetPasswordWithCode(props.code, password);
	if (success) {
		router.push({ name: "auth-login" });
	}
}
</script>
